import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isModalDisplayed: {
      display: false,
      isGranted: false,
      deniedReason: "",
      url: ""
    },
    userPersonality: [],
    userChoices: [],
    Two: {
      father: {
        lines: [
          "I decided to follow my father. I walked into the space as he worked the forge, beating down angrily with his hammer. There was something that I wanted to ask my father, a thing I overheard from the townspeople not long ago. I knew he won't like it, but it seemed to be the best time since the conversation that came up at dinner."
        ]
      },
      mother: {
        lines: [
          "I walked after my mother into her flower garden. She looked a little distraught so I put a reassuring arm around her. “Your father never believes that there’s good in the world”, she sights. “Maybe he’s right?” I asked. My mother looked up at me, her blue eyes soft and comforting. “You know”, she said,  “I used to be like him when I was younger. I’ve never trusted in anything or anyone and almost lost hope during the last war, I thought there was no way out, but help was on its way and the brave soldiers of the army arrived just in time to save me from the Gremlins. I’ve learned to believe that there is good in the world and everything happens for a reason, I learned to never lose hope.” “What if it doesn’t always work that way?” I ask, still a little unsure. “Sara, darling”, my mother gently stroked my hair. “I want you to be happy and you can’t ever be happy if you lose hope, if you think everything will turn out bad. So please remember, no matter how bad you think things are, trust that it’s for a reason, trust the magic of the Fairy Queen and trust that everything would be okay.”",
          "My mother never mentioned the Fairy Queen again, but we grew closer after that day and I learned many valuable lessons from her."
        ]
      }
    },
    Three: {
      ask: {
        lines: [
          "“Are we going to be okay? Do you know that things are bad because you used to be a soldier?” My dad stopped working and stared at me. “No” he said angrily “and don’t talk to me about that ever again”. “But dad…” I start. “Leave. Now” he screamed. I recoil almost in tears, my father has always been blunt, but he had never been this angry at me. I slowly backed away towards the door when he looked up, his eyes softer. “Sarah.. I.. I didn’t mean that. I just wanted to keep you safe, naive about that kind of life. I myself grew up hearing my father's stories of war eager to hear the next, a curious child just like you... it was not as glorious a life as I imagined. When I met your mother I saw a chance at a life renewed and have never looked back since, but I guess there is no point hiding anything now.........”. I looked at him, afraid of what I might hear. “I used to be like your mother once, I used to trust the system until it failed me. When I was your age, the army promised to protect us and I believed them. I believed them and I payed for it. I had to watch my sister get killed in a Gremlin raid unable to do anything, she died in my arms. This stuff changes you Sara, I joined the army thinking I could make a difference, to help protect my home town from the raids in service to the army and realized that there was nothing that I could do, that the presence of a guard doesn't always equal safety”. I listened and my heart ached with pain for this man I thought I knew so well. “I’m sorry dad…I'm so sorry…” I stammered. “Don’t be, it’s not your fault. I am telling you this so you don’t make my mistake. Use your head and don’t trust in hope, remember that the presence of a guard doesn’t equal safety. All I ever wanted was to give you a life better than I had. Listen Sara, if the war happens, if I’m not around, go to Councilor Great, he will help you”.",
          "My father never mentioned Councilor Great again, but we grew closer after that day and I learned many valuable lessons from him."
        ],
        requiredTrait: "Courageous"
      },
      notAsk: {
        lines: [
          "I stared at my father for a while, but decided it's best to let it be."
        ],
        requiredTrait: ""
      }
    },
    Four: {
      none: {
        lines: [
          "Some time had passed and I completely forgot about that dinner and our conversation until the day that everything changed.",
          "I woke up startled in the middle of the night and looked around unsure of what was going on, but I felt it in my gut that something was wrong. And then it hit me, I could smell smoke and hear the cling of metal. The Gremlins were here. I got out of bed and grabbed my coat because I knew there wasn’t any time left. I could hear my sister crying for help downstairs and my dad trying to fight off the vicious monsters."
        ]
      }
    },
    Five: {
      fight: {
        lines: [
          "I didn’t know a thing about fighting but I ran down, grabbed a weapon one of the Gremlins must have dropped on the floor and engaged in combat."
        ],
        requiredTrait: "Courageous"
      },
      seekHelp: {
        lines: [
          "I felt terrible for leaving my family behind, but that was my best shot at getting help. I grabbed my backpack and sneaked out of the window of my room and quietly into the forest at the back of my house. As soon as I couldn't hear the Gremlins anymore I took off running as fast as I could until I reached Anixon and then I called for help as loudly as I could."
        ]
      },
      hide: {
        lines: [
          "I got back under my covers, closed my eyes and hoped. I hoped that my dad was strong enough to fight the monsters and save us from inevitable death and I trusted that help would come soon."
        ]
      }
    },
    Six: {
      // Block 9
      winFight__Father: {
        lines: [
          "Even though I've never done it before, sword fighting felt natural - as though I was born for it. And it wasn't long until my father and I were able to draw the Gremlins out of our house. We were safe for now, but we had to act quickly."
        ],
        requiredTrait: "CombatSkills"
      },
      // Block 10
      loseFight__Father: {
        lines: [
          `The sword felt heavy in my hand. I wasn't sure how to properly use it so I just waved it around and hoped it would get the Gremlins. My mother screamed out in pain and my father tried to fight off the group of Gremlins coming at him. We were heavily outnumbered and my mother was already on the floor - I was unsure if she was alive or not. I dashed to my sister and stabbed the large Gremlin coming at her. For a second I thought there weren't anymore Gremlins left, that we would be able to get out of this. But then I heard my father yell "Sara careful!", as he threw himself in front of me, pushing me towards the window and taking an arrow for me. "Get out of here! Run!!" As though my body took the order by its own will, I jumped out of the window. Without a second thought. The last thing I saw was another arrow hitting my sister in the back. I hauled myself back to my feet and ran as fast as I could through the forest and towards downtown Anixon. I was too numb to feel any pain and I knew I had to get help. I ran into the woodman's house and banged on his door with my fists. The elderly man looked startled when he opened the door, he knew me and noticed my panic. "Home... Gremlins.." I tried to catch my breath. "Oh no!" the woodman grabbed the bow and arrows behind his door and hurried towards my house. I would never forget what I saw - my family were on the floor in a pool of blood.  Not a single sign of the monsters who left their motionless bodies twisted. My pain and exhaustion gave way to an all consuming numbness.`
        ]
      },
      // Block 16
      winFight__Mother: {
        lines: [
          `Even though I've never done it before, sword fighting felt natural - as though I was born for it. And it wasn't long until my father and I were able to draw the Gremlins out of our house. We were safe for now, but we had to act quickly. I decided to go to Anixon and unite the townspeople against the Gremlins.`
        ],
        requiredTrait: "CombatSkills"
      },
      // Block 15
      loseFight__Mother: {
        lines: [
          `The sword felt heavy in my hand. I wasn't sure how to properly use it so I just waved it around and hoped it would get the Gremlins. My mother screamed out in pain and my father tried to fight off the group of Gremlins coming at him. We were heavily outnumbered and my mother was already on the floor - I was unsure if she was alive or not. I dashed to my sister and stabbed the large Gremlin coming at her. For a second I thought there weren't anymore Gremlins left, that we would be able to get out of this. But then I heard my father yell "Sara careful!", as he threw himself in front of me, pushing me towards the window and taking an arrow for me. "Get out of here! Run!!" As though my body took the order by its own will, I jumped out of the window. Without a second thought. The last thing I saw was another arrow hitting my sister in the back. I hauled myself back to my feet and ran as fast as I could through the forest and towards downtown Anixon. I was too numb to feel any pain and I knew I had to get help. I ran into the woodman's house and banged on his door with my fists. The elderly mad looked startled when he opened the door, he knew me and noticed my panic. "Home... Gremlins.." I tried to catch my breath. "Oh no!" the woodman grabbed the bow and arrows behind his door and hurried towards my house. I would never forget what I saw - my family were on the floor in a pool of blood.  Not a single sign of the monsters who left their motionless bodies twisted. My pain and exhaustion gave way to an all consuming numbness.`
        ]
      },
      // Block 18
      clanOne__Father: {
        lines: [
          "The townspeople never liked the Uno-Clan, the one my father (and hence I) belonged to and now in the time of trouble they refused to help me. After a while of fruitless cries I decided to return home. I would never forget what I saw - my family were on the floor in a pool of blood.  Not a single sign of the monsters who left their motionless bodies twisted. My pain and exhaustion gave way to an all consuming numbness."
        ],
        requiredTrait: "Uno-Clan"
      },
      // Block 19
      clanTwo__Father: {
        lines: [
          "The townspeople always liked the Dos-Clan my father belonged to and came to my aid in this time of need. They picked up their weapons and followed me home and we were able to come just in time to save them. My father and mother still couldn’t agree if we should leave or stay in Anixon and so we stayed, even though I'm not sure at what cost that is going to come."
        ],
        requiredTrait: "Dos-Clan"
      },
      // Block 13
      clanOne__Mother: {
        lines: [
          "My father belonged to a clan that was known for their weakness to Gremlins and so he was easily defeated. My family was dead and I had only myself to blame."
        ],
        requiredTrait: "Uno-Clan",
        end: true
      },
      // Block 14
      clanTwo__Mother: {
        lines: [
          "My father belonged to the Uno Clan who are known for their natural strength against Gremlins and so he was able to easily defeat them. We were safe for now though we had to act quickly because more were sure to come. I decided to go to Anixon and unite the townspeople against the Gremlins."
        ],
        requiredTrait: "Dos-Clan"
      }
    },
    Seven: {
      // Block 17
      leave: {
        lines: [
          "My dad and I managed to convince my mother to leave Anixon. We managed to find the Councilor Great and he offered my father to take us to the Land of Dreams."
        ]
      },
      // Block 27
      stay: {
        lines: [
          "I stayed in Anixon. I knew my future here is limited, but I didn't want to go anywhere else. And I doubt I ever will. Like my father, I joined the army to hopefully protect someone else from the fate I had to endure. I know it's not what he would of wanted for me, but this is what my life became."
        ]
      },
      // Block 28
      leaveToFind: {
        lines: [
          "I didn't want to stay in Anixon, its not what my father would of wanted for me. I sold the house and set off to find Councilor Great and when I did, he helped me just like my father said he would. He showed me the path to the Land of Dreams, the place everyone dreams to go to and where everything is possible. Things migth not be the same without my family, but at least they would be proud knowing that I've got a shot at having a better life."
        ]
      },
      // Block 33
      sorrow: {
        lines: [
          "I stayed in Anixon and picked up my father's craft. I could not forgive my family's death, and in time, I became more and more like my father."
        ],
        end: true
      },
      // Block 22
      notUnite__Clan: {
        lines: [
          "The townspeople did not listen and had no motivation to unite among themselves. And, they weren't strong enough to defend themselves from the Gremlin raids that became even more frequent."
        ]
      },
      // Block 23
      unite__Clan: {
        lines: [
          "The townspeople became united under my hopeful and kind leadership and became able to defend Anixon from the Gremlin raids. It is now a safe and beautiful place to live in."
        ],
        requiredTrait: "Leadership"
      },
      // Block 24
      findFairy: {
        lines: [
          `I wandered around for long, but just like my mother taught me, I didn't lose hope. And eventually I found the Fairy Queen. She admired my resemblance to my mother. "Sweet child o mine, may happiness fill your heart in the Land of Dreams", she told me as she led me down the narrow path and into bright sunlight.`
        ]
      },
      // Block 25
      notUnite__Fight: {
        lines: [
          "The townspeople did not listen and had no motivation to unite among themselves. And, they weren't strong enough to defend themselves from the Gremlin raids that became even more frequent.",
          "But my father and mother still couldn't agree on whether or not we should leave Anixon and so we ended up staying, though I still don't know at what cost that may come."
        ]
      },
      // Block 26
      unite__Fight: {
        lines: [
          "The townspeople became united under my hopeful and kind leadership and became able to defend Anixon from the Gremlin raids. It is now a safe and beautiful place to live in."
        ],
        requiredTrait: "Leadership"
      }
    },
    Eight: {
      // Block 31
      sorrow: {
        lines: [
          "Not being able to go to the Land of Dreams would mean that I would never get the future my parents wanted for me."
        ]
      },
      // Block 32
      goal: {
        lines: [
          "Going to the Land of Dreams means I would be able to live out all my childhood dreams and have a better future nonetheless. I know that my family has gone through so many hardships to get there and I am incredibly grateful for it."
        ],
        requiredTrait: "Uno-Clan"
      }
    }
  },
  mutations: {
    resetUserData(state, payload) {
      if (payload) {
        state.userPersonality = [];
        state.userChoices = [];
      }
    },
    setUserPersonality(state, payload) {
      // "INDEX": "PERSONALITY"
      state.userPersonality.push(payload);
    },
    setUserChoice(state, payload) {
      // "INDEX": "PERSONALITY"
      state.userChoices.push(payload);
    },
    setModalDisplay(state, payload) {
      state.isModalDisplayed = {
        ...state.isModalDisplayed,
        ...payload
      };
    }
  },
  actions: {
    updatePersonality({ commit }, payload) {
      commit("setUserPersonality", payload);
    },
    updateChoice({ commit }, payload) {
      commit("setUserChoice", payload);
    }
  }
});
